import type { ProviderGetImage } from '@nuxt/image'

export const getImage: ProviderGetImage = (src, { modifiers = {} } = {}) => {
    const url = new URL(src, 'https://placeholder.local')
    const isAbsolute = src.startsWith('http')

    if (modifiers.width) {
        url.searchParams.set('width', String(modifiers.width))
    }

    return {
        url: isAbsolute ? url.toString() : `${url.pathname}${url.search}`
    }
}
